/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Page_Value_LeadInputs */

const en_pricing_page_value_lead = /** @type {(inputs: Pricing_Page_Value_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One app`)
};

const pl_pricing_page_value_lead = /** @type {(inputs: Pricing_Page_Value_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jedna aplikacja`)
};

/**
* | output |
* | --- |
* | "One app" |
*
* @param {Pricing_Page_Value_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const pricing_page_value_lead = /** @type {((inputs?: Pricing_Page_Value_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Page_Value_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_pricing_page_value_lead(inputs)
	return en_pricing_page_value_lead(inputs)
});